var React = require('react');

function PenAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M498 74.17a48 48 0 0 1 0 67.91l-56.6 56.55-128-128 56.55-56.55a48 48 0 0 1 67.91 0z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M336 138.49l82.77 82.77L222 418.05a327 327 0 0 1-195.34 93.8A24 24 0 0 1 .15 485.34v-.23A327 327 0 0 1 94 290l151.52-151.52-22.63-22.62-101.82 101.82a16 16 0 0 1-22.63 0l-22.63-22.63a16 16 0 0 1 0-22.62L194.59 53.64a40 40 0 0 1 56.56 0z","className":"fa-primary","key":2})]);
}

PenAlt.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = PenAlt;

PenAlt.default = PenAlt;
